import { ChainId } from '@aave/contract-helpers';
import { Box, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import AnalyticsConsent from 'src/components/Analytics/AnalyticsConsent';
// import { useModalContext } from 'src/hooks/useModal';
import { SupportModal } from 'src/layouts/SupportModal';
import { FORK_ENABLED, SWARD_ONLY } from 'src/utils/marketsAndNetworksConfig';

import { AppFooter } from './AppFooter';
import { AppHeader } from './AppHeader';
import TopBarNotify from './TopBarNotify';

const getCampaignConfigs = () => ({
  [ChainId.base]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
  },

  [ChainId.sonic]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
    // icon: '/icons/networks/sonic.svg',
  },

  [ChainId.mainnet]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
  },

  [ChainId.polygon]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
    // icon: '/icons/networks/polygon.svg',
  },

  [ChainId.avalanche]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
    // icon: '/icons/networks/avalanche.svg',
  },

  [ChainId.arbitrum_one]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
    // icon: '/icons/networks/arbitrum.svg',
  },

  [ChainId.optimism]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
    // icon: '/icons/networks/optimism.svg',
  },

  [ChainId.xdai]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
    // icon: '/icons/networks/gnosis.svg',
  },

  [ChainId.bnb]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
    // icon: '/icons/networks/binance.svg',
  },

  [ChainId.ink]: {
    notifyText: 'Aave V4 is now live on Ethereum mainnet.',
    buttonText: 'Try it out here',
    buttonAction: {
      type: 'url' as const,
      value: 'https://pro.aave.com/',
      target: '_blank' as const,
    },
    bannerVersion: 'aave-pro-mainnet-v1',
    // icon: '/icons/networks/ink.svg',
  },
});

// For defining Route specific campaigns if needed in future
const routeCampaigns = {
  // '/sgho': {
  //   notifyText: "Earn 4% higher yield on savings GHO using OKX's GHO staking vault.",
  //   buttonText: 'Learn more',
  //   buttonAction: {
  //     type: 'url' as const,
  //     value: 'https://web3.okx.com/earn/activity/aave-gho',
  //     target: '_blank' as const,
  //   },
  //   bannerVersion: 'sgho-okx-v1',
  // },
};

export function MainLayout({ children }: { children: ReactNode }) {
  const campaignConfigs = getCampaignConfigs();

  return (
    <>
      {process.env.NEXT_PUBLIC_SWARD_ONLY === 'true' ? (
        <Box
          role="status"
          sx={{
            bgcolor: '#18263d',
            color: '#fff',
            px: 2,
            py: 1,
            textAlign: 'center',
          }}
        >
          <Typography variant="caption" sx={{ fontWeight: 600 }}>
            Temporary testnet interface — experimental, unaudited, and not affiliated with or
            operated by Aave Labs.
          </Typography>
        </Box>
      ) : (
        <TopBarNotify campaigns={campaignConfigs} routeCampaigns={routeCampaigns} />
      )}

      <AppHeader />
      <Box component="main" sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        {children}
      </Box>
      <AppFooter />
      {!SWARD_ONLY && <SupportModal />}
      {FORK_ENABLED || SWARD_ONLY ? null : <AnalyticsConsent />}
    </>
  );
}
